import React, { useEffect, useState } from "react";
import classes from './Filter.module.css';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";


/**
    * get list as props
    * and 2 children:
    * first Filters with array of Filter children
    * second FilterItem with 1 children that FilterExtention pass into it param named filteredList that contain the filtered list
    * according to conditions in Filters array 
    */
const FilterExtention = ({ children, list }) => {
    const [filteredList, setFilteredList] = useState(list);

    validateFilterExtentionChildrenTree(children);

    return (<>
        <Filters list={list} setFilteredList={setFilteredList}>{children[0].props.children}</Filters>
        <FilterItem filteredList={filteredList}>
            {children[1].props.children}
        </FilterItem>
    </>)
}
FilterExtention.propsTypes = {
    stateOfList: PropTypes.array,
    setStateOfList: PropTypes.func
}

const Filters = React.memo(({ children, list, setFilteredList }) => {
    const [filtersInputs, setFilterInputs] = useState(children.rduce((inputs, filter) => {
        inputs[filter.props.name] = '';
        return inputs
    }, {}));

    useEffect(() => {
        const filteredList = list && list.filter(x =>
            Object.keys(filtersInputs).map(key => {
                if (key === "free") {
                    if (!filtersInputs[key] || (filtersInputs[key] && Object.keys(x).some(field => x[field].includes && x[field].includes(filtersInputs[key]))))
                        return true;
                    else
                        return false
                }
                else
                    if (!filtersInputs[key] || (filtersInputs[key] && x[key].includes(filtersInputs[key])))
                        return true;
                    else
                        return false;
            }).every(x => x === true)
        );
        setFilteredList(filteredList)
    }, [filtersInputs, list, setFilteredList])

    const handleChangeInputs = (event) => {
        setFilterInputs(prevFilterInputs => {
            const newFilterInputs = { ...prevFilterInputs }
            newFilterInputs[event.target.name] = event.target.value;
            return newFilterInputs;
        });
    }

    return <div className={classes.Filter}>
        {children.map(filter => <Filter key={filter.props.name} {...filter.props} handleChange={handleChangeInputs} value={filtersInputs[filter.props.name]} list={list}></Filter>)}
    </div>
})
Filters.propsTypes = {
    list: PropTypes.array,
    setFilteredList: PropTypes.func
}

const FilterTypesEnum = {
    free: 1,
    values: 2
}

const Filter = ({ name, text, type, handleChange, value, list }) => {
    const texts = useSelector(state => state.translate.texts);

    switch (type) {
        case FilterTypesEnum.free:
            return (<div key={name} className={classes.WrapInput}>
                <input type='text' placeholder={text} name="free" className={classes.Input} onChange={handleChange} ></input>
                <div className={classes.FilterIcon}></div>
            </div>)
        case FilterTypesEnum.values:
            return (<div key={name} className={classes.WrapInput}>
                <label className={classes.Label}>{text}</label>
                <select className={classes.Select} name={name} onChange={handleChange} >
                    <option value={""}>{texts.all}</option>
                    {list && [...new Set(list.map(item => item[name]))].map(item => <option key={item}>{item}</option>)}
                </select>
            </div>)
        default:
            return null
    }
}
Filter.propsTypes = {
    name: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.oneOf([FilterTypesEnum.free, FilterTypesEnum.values]),
}

const FilterItem = ({ children, filteredList }) => {
    return React.cloneElement(children, {
        filteredList: filteredList
    })
}
FilterItem.propsTypes = {
    children: PropTypes.node,
    filteredList: PropTypes.array
}

const validateFilterExtentionChildrenTree = (children) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        let error;
        if (children instanceof Array) {
            if (children.length > 2)
                error = "Filter expect exactly 2 children Filters and FilterItem"
            else if (children[0].type !== Filters)
                error = "Filter first child must be instace of Filters"
            else {
                if (children[1].type !== FilterItem)
                    error = "Filter second child must be instace of FilterItem";
                if (((children[0].props.children instanceof Array && children[0].props.children.some(f => f.type !== Filter)) || (!(children[0].props.children instanceof Array) && children[0].props.children.type !== Filter)))
                    error = "Filters has children that aren't Filter component";
                if (children[1].props.children instanceof Array)
                    error = "FilterItem expect exactly 1 children";
            }
        } else {
            error = "Filter expect exactly 2 children Filters and FilterItem";
        }
        if (error)
            throw new Error(`${error} note that there are no unnecessary spaces`);
    }
}


export { FilterExtention, FilterTypesEnum, FilterItem, Filter, Filters };